import { CLIENTS, CLIENT_QUOTES, PLATFORM_ACCESS_REQUEST, UPDATE_PLATFORM_ACCESS_REQUEST} from './ClientsAction';
import { Map } from 'immutable';

let defaultState = new Map({
  isFetching: false,
  error: false,
  data: []
});

export default function organizations(state = defaultState, action) {
  switch (action.type) {
    case CLIENTS.REQUEST:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: false,
      }));
    case CLIENTS.SUCCESS:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: false,
        data: action.payload
      }));
    case CLIENTS.FAILURE:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: action.error
      }));
    default:
      return state;
  }
}


export const quotes = (state  = defaultState, action) => {
  switch (action.type) {
    case CLIENT_QUOTES.REQUEST:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: false,
      }));
    case CLIENT_QUOTES.SUCCESS:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: false,
        data: action.payload
      }));
    case CLIENT_QUOTES.FAILURE:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: action.error
      }));
    default:
      return state;
  }
}

export const accessRequests = (state  = defaultState, action) => {
  switch (action.type) {
    case PLATFORM_ACCESS_REQUEST.REQUEST:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: false,
      }));
    case PLATFORM_ACCESS_REQUEST.SUCCESS:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: false,
        data: action.payload
      }));
    case PLATFORM_ACCESS_REQUEST.FAILURE:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: action.error
      }));
    default:
      return state;
  }
}

export const updateAccessRequests = (state  = defaultState, action) => {
  switch (action.type) {
    case UPDATE_PLATFORM_ACCESS_REQUEST.REQUEST:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: false,
      }));
    case UPDATE_PLATFORM_ACCESS_REQUEST.SUCCESS:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: false,
        data: action.payload
      }));
    case UPDATE_PLATFORM_ACCESS_REQUEST.FAILURE:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: action.error
      }));
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/containers/Clients/ClientsReducer.js